var _path, _path2, _circle;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBtnIcon08(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 20.3617L12.7724 19.6471L12.25 19.8134V20.3617H13ZM13 30H12.25V31.6013L13.4801 30.5762L13 30ZM16 27.5L16.4801 26.9238L16 26.5237L15.5199 26.9238L16 27.5ZM19 30L18.5199 30.5762L19.75 31.6013V30H19ZM19 20.3617H19.75V19.8134L19.2276 19.6471L19 20.3617ZM17.8641 20L18.0917 19.2854L17.9806 19.25H17.8641V20ZM17.8633 20V19.25H17.532L17.3089 19.4949L17.8633 20ZM16 22.0451L15.4456 22.5503L16 23.1588L16.5544 22.5503L16 22.0451ZM14.1367 20L14.6911 19.4949L14.468 19.25H14.1367V20ZM14.1359 20V19.25H14.0194L13.9083 19.2854L14.1359 20ZM12.25 20.3617V30H13.75V20.3617H12.25ZM13.4801 30.5762L16.4801 28.0762L15.5199 26.9238L12.5199 29.4238L13.4801 30.5762ZM15.5199 28.0762L18.5199 30.5762L19.4801 29.4238L16.4801 26.9238L15.5199 28.0762ZM19.75 30V20.3617H18.25V30H19.75ZM19.2276 19.6471L18.0917 19.2854L17.6365 20.7146L18.7724 21.0764L19.2276 19.6471ZM17.8641 19.25H17.8633V20.75H17.8641V19.25ZM17.3089 19.4949L15.4456 21.54L16.5544 22.5503L18.4177 20.5051L17.3089 19.4949ZM16.5544 21.54L14.6911 19.4949L13.5823 20.5051L15.4456 22.5503L16.5544 21.54ZM14.1367 19.25H14.1359V20.75H14.1367V19.25ZM13.9083 19.2854L12.7724 19.6471L13.2276 21.0764L14.3635 20.7146L13.9083 19.2854Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 2L18.0706 4.27259L21 3.33975L21.6569 6.34315L24.6603 7L23.7274 9.92945L26 12L23.7274 14.0706L24.6603 17L21.6569 17.6569L21 20.6603L18.0706 19.7274L16 22L13.9294 19.7274L11 20.6603L10.3431 17.6569L7.33975 17L8.27259 14.0706L6 12L8.27259 9.92945L7.33975 7L10.3431 6.34315L11 3.33975L13.9294 4.27259L16 2Z",
    stroke: "white",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 12,
    r: 4,
    stroke: "white",
    strokeWidth: 1.5
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnIcon08);
export default __webpack_public_path__ + "static/media/btn_icon08.4bcb90925508fdc1ff5b4bc4fdbf792a.svg";
export { ForwardRef as ReactComponent };